import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LandingPage } from './pages/LandingPage';
import { AboutPage } from './pages/AboutPage';
import { BusinessDetailPage } from './pages/BusinessDetailPage';
import { ContactPage } from './pages/ContactPage';
import { Navbar } from './components/Navbar';
import { LoadingScreen } from './components/LoadingScreen';
import { ScrollProgress } from './components/ScrollProgress';
import { LanguageProvider } from './context/LanguageContext';
export type Page = 'home' | 'about' | 'contact' | 'business';
function AppContent() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const [currentSlug, setCurrentSlug] = useState<string>('');
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);
  const handleNavigate = (page: Page, slug?: string) => {
    setCurrentPage(page);
    if (slug) setCurrentSlug(slug);
    window.scrollTo(0, 0);
  };
  return <>
      <AnimatePresence data-id="element-0">{isLoading && <LoadingScreen data-id="element-1" />}</AnimatePresence>

      {!isLoading && <>
          <ScrollProgress data-id="element-2" />
          <Navbar currentPage={currentPage === 'business' ? 'home' : currentPage} onNavigate={page => handleNavigate(page)} data-id="element-3" />

          <AnimatePresence mode="wait" data-id="element-4">
            {currentPage === 'home' && <motion.div key="home" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-5">
                <LandingPage onNavigate={handleNavigate} data-id="element-6" />
              </motion.div>}

            {currentPage === 'about' && <motion.div key="about" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-7">
                <AboutPage data-id="element-8" />
              </motion.div>}

            {currentPage === 'contact' && <motion.div key="contact" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-9">
                <ContactPage data-id="element-10" />
              </motion.div>}

            {currentPage === 'business' && <motion.div key={`business-${currentSlug}`} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} data-id="element-11">
                <BusinessDetailPage slug={currentSlug} onNavigate={handleNavigate} data-id="element-12" />
              </motion.div>}
          </AnimatePresence>
        </>}
    </>;
}
export function App() {
  return <LanguageProvider data-id="element-13">
      <AppContent data-id="element-14" />
    </LanguageProvider>;
}